import { defineStore } from 'pinia';

import type { Cart } from '~/modules/GraphQL/types';

interface CustomerState {
  cart: Cart,
  pendingMutations: number,
  needsReconciliation: boolean,
}

export const useCartStore = defineStore('cart', {
  state: (): CustomerState => ({
    pendingMutations: 0,
    needsReconciliation: false,
    cart: {
      id: '', is_virtual: false, total_quantity: 0, shipping_addresses: [],
    },
  }),
});
